import styled from '@emotion/styled';
import React from 'react';
import useSWR from 'swr';

import { detailFetcher } from './helpers';

const PostalItemDetailWrapper = styled('div', {
  label: 'postal-item-detail-wrapper',
})`
  height: 100%;
  overflow-y: auto;

  & > .content {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    height: 100%;

    @media (orientation: landscape) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto 1fr auto;
      padding: 0.62rem 1rem;
      height: fit-content;

      & > div:first-of-type {
        grid-row: 1 / 3;
      }
      & > div:last-of-type {
        grid-row: 2 / 3;
      }
    }
  }
`;

const Card = styled('div', {
  label: 'card',
})`
  background-color: white;
  padding: 1.25rem 1.5rem;
  display: grid;
  grid-template-columns: 7.15rem 1fr;
  row-gap: 0.75rem;
  height: fit-content;
  & > .text {
    font-size: 0.9rem;
  }
  & > .label {
    color: #8b8b8b;
  }
  & > .content {
    color: #383838;
  }
  & > .photo {
    aspect-ratio: 1;
    width: 7rem;
    object-fit: cover;
  }
  & > .signature {
    width: 100%;
    height: 5.75rem;
    object-fit: cover;
  }
`;

const ButtonDiv = styled('div', {
  label: 'button-div',
})`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1.5rem;

  & > button {
    width: 100%;
    height: 2.5rem;
    border: none;
    border-radius: 0.25rem;
    background-color: #69b49e;
    color: white;
    font-size: 0.9rem;
  }

  @media (orientation: landscape) {
    justify-content: flex-start;
    padding: 0;
  }
`;

const PostalItemDetail: React.FC<{ postalId: string; onClose: () => void }> = ({
  postalId,
  onClose,
}) => {
  const fetchUrl = `/ezcon/api/app/postalRegistration/${postalId}`;

  const { data: postal, error } = useSWR(fetchUrl, detailFetcher);

  console.log({ postal, error });

  return (
    <PostalItemDetailWrapper>
      <div className="content">
        {postal && (
          <>
            <Card>
              <span className="text label">編號</span>
              <span className="text content">{postal.plateNumber}</span>
              <span className="text label">收件人</span>
              <span className="text content">{postal.receiver}</span>
              <span className="text label">包裹狀態</span>
              <span className="text content">{postal.status}</span>
              <span className="text label">包裹類型</span>
              <span className="text content">{postal.type}</span>
              <span className="text label">擺放位置</span>
              <span className="text content">{postal.position}</span>
              <span className="text label">備註</span>
              <span className="text content">{postal.remark}</span>
            </Card>
            <Card>
              <span className="text label">登記時間</span>
              <span className="text content">{postal.createdTime}</span>
              <span className="text label">領取時間</span>
              <span className="text content">{postal.receiveTime}</span>
            </Card>
            {(postal.photo || postal.signature) && (
              <Card>
                {postal.photo && (
                  <>
                    <span className="text label">領取人照片</span>
                    <img
                      className="photo"
                      src={postal.photo}
                      alt="receiver photo"
                    />
                  </>
                )}
                {postal.signature && (
                  <>
                    <span className="text label">領取人簽名</span>
                    <img
                      className="signature"
                      src={postal.signature}
                      alt="receiver signature"
                    />
                  </>
                )}
              </Card>
            )}
          </>
        )}
        <ButtonDiv>
          <button onClick={onClose}>關閉</button>
        </ButtonDiv>
      </div>
    </PostalItemDetailWrapper>
  );
};

export default PostalItemDetail;
